export default "__VITE_ASSET__AW691j4h__"